import { NgModule, ModuleWithProviders } from '@angular/core';
import { JwtService } from './services/jwt.service';
import { UiHelperModule } from '../ui-helper/ui-helper.module';
import { JWT_KEY_NAME } from './constants/consts';

@NgModule({
  imports: [
    UiHelperModule.forRoot()
  ],
  declarations: [],
  providers:
  [ 
  ],
  exports:[]
})
export class JwtModule {
  static forRoot(jwtKeyName: string): ModuleWithProviders<JwtModule> {
    return {
      ngModule: JwtModule,
      providers: [
        JwtService,
        {
          provide: JWT_KEY_NAME,
          useValue: jwtKeyName
        }
      ]
    }
  }

}
